export const projectID = '8b97db5a8d7842ac8b47059d234b1bbe'
export const nftmarketaddress = '0xdf6A53062CE625fd65B1555c200f80AdA950fdB9'
export const nftaddress = '0xe8b465cD51B1Ae255807DCD76fAa3CdA17Eb21E4'
// Test Addresses
// export const aferTokenAddress = '0xB7f8BC63BbcaD18155201308C8f3540b07f84F5e'
// export const seedSaleAddress = '0xA51c1fc2f0D1a1b8494Ed1FE312d7C3a78Ed91C0'
// Mumbai Addresses V1
// export const aferTokenAddress = '0xCCA24B90b4FAaac4a3106A353c135112ee0A49eb'
// export const seedSaleAddress = '0x051c7b1a691a134C94ff38c4E58cE8A150Bf38d0'

// Mumbai Addresses V2
export const aferTokenAddress = '0x5D30F9E037fE532B1DFAa11C53b97d6A85C55edd'
export const seedSaleAddress = '0x62308e5A9E292FB00d4E30f0FE573c4c60fAEE55'
